import React, { useState, useEffect } from 'react';
import './home.scss';
import { useNavigate } from "react-router-dom";
import notify from 'devextreme/ui/notify';
import { useAuth } from '../../contexts/auth';
import devices from 'devextreme/core/devices';

export default function Home() {
  const { user, refreshSession } = useAuth();
  const navigate = useNavigate();
  const [groups, setGroups] = useState(null);

  useEffect(() => {
    if (user && user.signInUserSession) {
      const cognitoGroups = user.signInUserSession.idToken.payload['cognito:groups'];
      if (cognitoGroups) {
        setGroups(cognitoGroups.join());
      } else {
        setGroups('');
      }
    }
  }, [user]);


  return (
    <React.Fragment>

      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings mb-4'}>
          <div className={'d-flex flex-column align-items-center'}>
            <div className={'logos-container'}>
              <img src='/AXPC-logo.png' className="img-fluid mt-1" style={{maxWidth: "100%"}}/>
            </div>
            <h3 className={'mb-2 text-center'}>Welcome to the AXPC Members Portal</h3>
          </div>
        </div>
      </div>
      {groups && (groups.includes("aiuser") || groups.includes("kbmanager") || groups.includes("admin")) && (
        <React.Fragment>
          <h2 className="content-block mt-5">AI Tools</h2>
          <hr className="mt-0 mb-2"></hr>
          <div className="row">
            <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-3 pt-2">
              <div className="dx-card shortcut-card" key={"axpc_assistant"}
                onClick={() => {navigate('/axpc-assistant');}}>
                <div className="mt-3 d-flex flex-column align-items-center">
                  <span className="fa-stack fa-2x">
                    <i className="fas fa-robot fa-stack-2x" style={{color:'#5cc2d7'}}></i>
                    <i className="fas fa-comment fa-stack-1x" style={{color:'#144d6d', paddingTop:"2.3rem" , paddingLeft: "4rem"}}></i>
                  </span>
                  <h5 className="mt-4 text-center">AXPC Assistant</h5>
                </div>
              </div>
            </div>
            {(groups.includes("kbmanager") || groups.includes("admin")) && (
              <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-3 pt-2">
                <div className="dx-card shortcut-card" key={"ai_knowledge_base"}
                  onClick={() => {navigate('/ai-knowledge-base');}}>
                  <div className="mt-3 d-flex flex-column align-items-center">
                    <span className="fa-stack fa-2x">
                      <i className="fas fa-book fa-stack-2x" style={{color:'#5cc2d7'}}></i>
                      <i className="fas fa-database fa-stack-1x" style={{color:'#144d6d', paddingTop:"2.3rem" , paddingLeft: "4rem"}}></i>
                    </span>
                    <h5 className="mt-4 text-center">AI Knowledge Base</h5>
                  </div>
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      )}

      {groups && (groups.includes("sifro") || groups.includes("sifrw") || groups.includes("esgro") || groups.includes("hsero") || groups.includes("admin")) && (
        <React.Fragment>
          <h2 className="content-block mt-5">Reports</h2>
          <hr className="mt-0 mb-2"></hr>
          <div className="row">
            {groups.includes("sifro") || groups.includes("sifrw") || groups.includes("admin") ? (
              <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-3 pt-2">
                <div className="dx-card shortcut-card" key={"new_case"}
                  onClick={() => {navigate('/sif');}}>
                  <div className="mt-3 d-flex flex-column align-items-center">
                    <span className="fa-stack fa-2x">
                      <i className="fas fa-user-injured fa-stack-2x" style={{color:'#5cc2d7'}}></i>
                      <i className="far fa-chart-bar fa-stack-1x" style={{color:'#144d6d', paddingTop:"2.3rem" , paddingLeft: "4rem"}}></i>
                    </span>
                    <h5 className="mt-4 text-center">Serious Injury or Fatality Report</h5>
                  </div>
                </div>
              </div>
            ) : null}
            {groups.includes("esgro") || groups.includes("admin") ? (
              <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-3 pt-2">
                <div className="dx-card shortcut-card" key={"new_case"}
                  onClick={() => {navigate('/esg');}}>
                  <div className="mt-3 d-flex flex-column align-items-center">
                    <span className="fa-stack fa-2x">
                      <i className="fas fa-leaf fa-stack-2x" style={{color:'#5cc2d7'}}></i>
                      <i className="far fa-chart-bar fa-stack-1x" style={{color:'#144d6d', paddingTop:"2.3rem" , paddingLeft: "4rem"}}></i>
                    </span>
                    <h5 className="mt-4 text-center">Environmental, Social & Governance Benchmarking</h5>
                  </div>
                </div>
              </div>
            ) : null}
            {groups.includes("hsero") || groups.includes("admin") ? (
              <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-3 pt-2">
                <div className="dx-card shortcut-card" key={"new_case"}
                  onClick={() => {navigate('/hse');}}>
                  <div className="mt-3 d-flex flex-column align-items-center">
                    <span  className="fa-stack fa-2x">
                      <i  className="fas fa-heartbeat fa-stack-2x" style={{color:'#5cc2d7'}}></i>
                      <i  className="far fa-chart-bar fa-stack-1x" style={{color:'#144d6d', paddingTop:"2.3rem" , paddingLeft: "4rem"}}></i>
                    </span>
                    <h5 className="mt-4 text-center">Health, Safety & Environmental Survey</h5>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </React.Fragment>
      )}

      {groups && (groups.includes("sifrw") || groups.includes("admin")) && (
        <React.Fragment>
          <h2 className="content-block mt-5">Report New SIF Events</h2>
          <hr className="mt-0 mb-2"></hr>
          <div className="row">
            <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-3 pt-2">
              <div className="dx-card shortcut-card" key={"new_case"}
                onClick={() => {navigate('/sifupload');}}>
                <div className="mt-3 d-flex flex-column align-items-center">
                  <span className="fa-stack fa-2x">
                    <i className="fas fa-user-injured fa-stack-2x" style={{color:'#5cc2d7'}}></i>
                    <i className="fas fa-table fa-stack-1x" style={{color:'#144d6d', paddingTop:"2.3rem" , paddingLeft: "4rem"}}></i>
                  </span>
                  <h5 className="mt-4 text-center">Bulk Upload Serious Injury or Fatality Events</h5>
                </div>
              </div>
            </div>
            <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-3 pt-2">
              <div className="dx-card shortcut-card" key={"new_case"}
                onClick={() => {navigate('/sifdata');}}>
                <div className="mt-3 d-flex flex-column align-items-center">
                  <span className="fa-stack fa-2x">
                    <i className="fas fa-user-injured fa-stack-2x" style={{color:'#5cc2d7'}}></i>
                    <i className="fas fa-database fa-stack-1x" style={{color:'#144d6d', paddingTop:"2.3rem" , paddingLeft: "4rem"}}></i>
                  </span>
                  <h5 className="mt-4 text-center">Serious Injury or Fatality Company Data</h5>
                </div>
              </div>
            </div>
            <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-3 pt-2">
              <div className="dx-card shortcut-card" key={"new_case"}
                onClick={() => {navigate('/sifevent');}}>
                <div className="mt-3 d-flex flex-column align-items-center">
                  <span className="fa-stack fa-2x">
                    <i className="fas fa-user-injured fa-stack-2x" style={{color:'#5cc2d7'}}></i>
                    <i className="fas fa-file-medical fa-stack-1x" style={{color:'#144d6d', paddingTop:"2.3rem" , paddingLeft: "4rem"}}></i>
                  </span>
                  <h5 className="mt-4 text-center">Add Serious Injury or Fatality Event</h5>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}

      {groups && (groups.includes("sifrw") || groups.includes("admin")) && (
        <React.Fragment>
          <h2 className="content-block mt-5">How-To Videos</h2>
          <hr className="mt-0 mb-2"></hr>
          <div className="row">
            <div className="d-flex flex-row justify-content-center py-5">
              {devices.current().deviceType === 'phone'?
                <div className="px-1 w-100">
                <div className="iframe-container">
                  <iframe className="responsive-iframe" width="100%" height="100%" src="https://www.youtube.com/embed/0ifn-976VuU?si=uJwWNkMxEjUFQmxV" title="AXPC Members Portal - How to submit a Serious Injury or Fatality event" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                </div></div>:
                <div className="px-5 iframe-container-parent">
                <div className="iframe-container">
                  <iframe className="responsive-iframe" width="100%" height="100%" src="https://www.youtube.com/embed/0ifn-976VuU?si=uJwWNkMxEjUFQmxV" title="AXPC Members Portal - How to submit a Serious Injury or Fatality event" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                </div>
                </div>
              }
              {devices.current().deviceType === 'phone'?
                <div className="px-1 w-100">
                <div className="iframe-container">
                  <iframe className="responsive-iframe" width="100%" height="100%" src="https://www.youtube.com/embed/LGx0xss8vO4?si=QYtg9DRH-zGwV2a6" title="AXPC Members Portal - How to submit multiple Serious Injury or Fatality events" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                </div></div>:
                <div className="px-5 iframe-container-parent">
                <div className="iframe-container">
                  <iframe className="responsive-iframe" width="100%" height="100%" src="https://www.youtube.com/embed/LGx0xss8vO4?si=QYtg9DRH-zGwV2a6" title="AXPC Members Portal - How to submit multiple Serious Injury or Fatality events" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                </div>
                </div>
              }
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
)}
